export const sliderItems = [
    {
      id: 1,
      img: "https://images.pexels.com/photos/5998119/pexels-photo-5998119.jpeg?cs=srgb&dl=pexels-max-vakhtbovych-5998119.jpg&fm=jpg",
      title: "DECORIA Home Decor.",
      desc: "Lets Get To Decorating",
      bg: "fcf1ed",
    },
    
    {
      id: 2,
      img: "https://images.pexels.com/photos/7535041/pexels-photo-7535041.jpeg?cs=srgb&dl=pexels-max-vakhtbovych-7535041.jpg&fm=jpg",
      title: "BEST SELLERS",
      desc: "Shop Our Best Sellers! | Free Shipping on All Continental US Orders!| International Shipping Now Available Worldwide!",
      bg: "fcf1ed",
    },
    {
      id: 3,
      img: "https://images.pexels.com/photos/817783/pexels-photo-817783.jpeg?cs=srgb&dl=pexels-vecislavas-popa-817783.jpg&fm=jpg",
      title: "VASES & PLANTERS",
      desc: "GET FLAT 30% OFF FOR NEW ARRIVALS.",
      bg: "fcf1ed",
    },
  ];

  export const categories = [
    {
      id: 1,
      img: "https://images.pexels.com/photos/1366872/pexels-photo-1366872.jpeg?cs=srgb&dl=pexels-evg-kowalievska-1366872.jpg&fm=jpg",
      title: "HOME DECOR",
    },
    {
      id: 2,
      img: "https://i.ibb.co/PGfggjD/mirror01.webp",
      
      title: "MIRROR & WALL ART",
    },
    
    {
      id: 3,
      img: "https://images.pexels.com/photos/4428629/pexels-photo-4428629.jpeg?cs=srgb&dl=pexels-karla-her-4428629.jpg&fm=jpg",
      title: " FLOWERS ",
    },
  ];

  export const popularProducts = [
    {
      id:1,
      img:"https://images.pexels.com/photos/2950326/pexels-photo-2950326.jpeg?cs=srgb&dl=pexels-jonathan-borba-2950326.jpg&fm=jpg",
      title: " Candle Holder ",
      desc:'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Voluptatem autem blanditiis iste facilis ut? Voluptatum quisquam, dicta corrupti asperiores dolor atque tempore harum dolores illo eveniet unde et in soluta',
      price:'9.99',
    },
    {
      id:2,
      img:"https://i.ibb.co/8rngRwY/mirror.webp",
      title: " Teardrop Mirrors(set of 5) ",
      desc:'These stunning teardrop mirrors are classic and timeless. Hang them anywhere in your home for an elegant and impressive look. We love the different sizes and how they complement each other so nicely.',
      price:'139.99',
    },
    {
      id:3,
      img:"https://images.pexels.com/photos/6479596/pexels-photo-6479596.jpeg?cs=srgb&dl=pexels-tara-winstead-6479596.jpg&fm=jpg",
      title: " FLOWERS ",
      desc:'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Voluptatem autem blanditiis iste facilis ut? Voluptatum quisquam, dicta corrupti asperiores dolor atque tempore harum dolores illo eveniet unde et in soluta',
      price:'49.99',
    },
    {
      id:4,
      img:"https://images.pexels.com/photos/6045196/pexels-photo-6045196.jpeg?cs=srgb&dl=pexels-skylar-kang-6045196.jpg&fm=jpg",
      title: " ceramic vase with Pink Flower ",
      desc:'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Voluptatem autem blanditiis iste facilis ut? Voluptatum quisquam, dicta corrupti asperiores dolor atque tempore harum dolores illo eveniet unde et in soluta',
      price:'29.99',
    },
    {
      id:5,
      img:"https://images.pexels.com/photos/3981635/pexels-photo-3981635.jpeg?cs=srgb&dl=pexels-daria-shevtsova-3981635.jpg&fm=jpg",
      title: " FLOWERS ",
      desc:'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Voluptatem autem blanditiis iste facilis ut? Voluptatum quisquam, dicta corrupti asperiores dolor atque tempore harum dolores illo eveniet unde et in soluta',
      price:'19.99',
    },
    {
      id:6,
      img:"https://images.pexels.com/photos/6438753/pexels-photo-6438753.jpeg?cs=srgb&dl=pexels-max-vakhtbovych-6438753.jpg&fm=jpg",
      desc:'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Voluptatem autem blanditiis iste facilis ut? Voluptatum quisquam, dicta corrupti asperiores dolor atque tempore harum dolores illo eveniet unde et in soluta',
      price:'59.99',
      title: " Mirror (set of 3) "
      
    },
   
  ]

  export const myProducts = [
    {
      id:1,
      img:"https://images.pexels.com/photos/6758233/pexels-photo-6758233.jpeg?cs=srgb&dl=pexels-max-vakhtbovych-6758233.jpg&fm=jpg",
      title: " Gold Vase ",
      desc:'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Voluptatem autem blanditiis iste facilis ut? Voluptatum quisquam, dicta corrupti asperiores dolor atque tempore harum dolores illo eveniet unde et in soluta',
      price:'19.99',
    },
    {
      id:2,
      img:"https://images.pexels.com/photos/6641247/pexels-photo-6641247.jpeg?cs=srgb&dl=pexels-karolina-grabowska-6641247.jpg&fm=jpg",
      title: " Clear Vase ",
      desc:'These stunning teardrop mirrors are classic and timeless. Hang them anywhere in your home for an elegant and impressive look. We love the different sizes and how they complement each other so nicely.',
      price:'14.99',
    },
    {
      id:3,
      img:"https://images.pexels.com/photos/6492401/pexels-photo-6492401.jpeg?cs=srgb&dl=pexels-max-vakhtbovych-6492401.jpg&fm=jpg",
      title: " Smoked stem vase ",
      desc:'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Voluptatem autem blanditiis iste facilis ut? Voluptatum quisquam, dicta corrupti asperiores dolor atque tempore harum dolores illo eveniet unde et in soluta',
      price:'49.99',
    },
    {
      id:4,
      img:"https://images.pexels.com/photos/8888147/pexels-photo-8888147.jpeg?cs=srgb&dl=pexels-melike-benli-8888147.jpg&fm=jpg",
      title: " Gold Mirror ",
      desc:'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Voluptatem autem blanditiis iste facilis ut? Voluptatum quisquam, dicta corrupti asperiores dolor atque tempore harum dolores illo eveniet unde et in soluta',
      price:'99.99',
    },
    {
      id:5,
      img:"https://images.pexels.com/photos/10789371/pexels-photo-10789371.jpeg?cs=srgb&dl=pexels-anna-belousova-10789371.jpg&fm=jpg",
      title: " Candle ",
      desc:'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Voluptatem autem blanditiis iste facilis ut? Voluptatum quisquam, dicta corrupti asperiores dolor atque tempore harum dolores illo eveniet unde et in soluta',
      price:'9.99',
    },
    {
      id:6,
      img:"https://images.pexels.com/photos/6438753/pexels-photo-6438753.jpeg?cs=srgb&dl=pexels-max-vakhtbovych-6438753.jpg&fm=jpg",
      desc:'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Voluptatem autem blanditiis iste facilis ut? Voluptatum quisquam, dicta corrupti asperiores dolor atque tempore harum dolores illo eveniet unde et in soluta',
      price:'59.99',
      title: "Mirror "
      
    },
    {
      id:7,
      img:"https://images.pexels.com/photos/2950326/pexels-photo-2950326.jpeg?cs=srgb&dl=pexels-jonathan-borba-2950326.jpg&fm=jpg",
      title: " Candle Holder ",
      desc:'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Voluptatem autem blanditiis iste facilis ut? Voluptatum quisquam, dicta corrupti asperiores dolor atque tempore harum dolores illo eveniet unde et in soluta',
      price:'9.99',
    },
    {
      id:8,
      img:"https://i.ibb.co/8rngRwY/mirror.webp",
      title: " Teardrop Mirrors(set of 5) ",
      desc:'These stunning teardrop mirrors are classic and timeless. Hang them anywhere in your home for an elegant and impressive look. We love the different sizes and how they complement each other so nicely.',
      price:'139.99',
    },
    {
      id:9,
      img:"https://images.pexels.com/photos/6479596/pexels-photo-6479596.jpeg?cs=srgb&dl=pexels-tara-winstead-6479596.jpg&fm=jpg",
      title: " FLOWERS ",
      desc:'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Voluptatem autem blanditiis iste facilis ut? Voluptatum quisquam, dicta corrupti asperiores dolor atque tempore harum dolores illo eveniet unde et in soluta',
      price:'49.99',
    },
    {
      id:10,
      img:"https://images.pexels.com/photos/6045196/pexels-photo-6045196.jpeg?cs=srgb&dl=pexels-skylar-kang-6045196.jpg&fm=jpg",
      title: " ceramic vase with Pink Flower ",
      desc:'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Voluptatem autem blanditiis iste facilis ut? Voluptatum quisquam, dicta corrupti asperiores dolor atque tempore harum dolores illo eveniet unde et in soluta',
      price:'29.99',
    },
    {
      id:11,
      img:"https://images.pexels.com/photos/3981635/pexels-photo-3981635.jpeg?cs=srgb&dl=pexels-daria-shevtsova-3981635.jpg&fm=jpg",
      title: " FLOWERS ",
      desc:'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Voluptatem autem blanditiis iste facilis ut? Voluptatum quisquam, dicta corrupti asperiores dolor atque tempore harum dolores illo eveniet unde et in soluta',
      price:'19.99',
    },
    {
      id:12,
      img:"https://images.pexels.com/photos/6438753/pexels-photo-6438753.jpeg?cs=srgb&dl=pexels-max-vakhtbovych-6438753.jpg&fm=jpg",
      desc:'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Voluptatem autem blanditiis iste facilis ut? Voluptatum quisquam, dicta corrupti asperiores dolor atque tempore harum dolores illo eveniet unde et in soluta',
      price:'59.99',
      title: " Mirror (set of 3) "
      
    },
   
  ]